import React from 'react';
import LoadStatus from '../utilities/load-status';
import Select from './pieces/select';
import PropTypes from 'prop-types';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data
    };
    this.loadForm = this.loadForm.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.convertToDataType = this.convertToDataType.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  loadForm() {
    return this.props.fields.map((field, i) => {
      const required = field.required || false;
      const disabled = field.disabled || false;
      const fieldVal = this.state.data && this.state.data[field.id.replace(/-/g, '_')] !== null ? this.state.data[field.id.replace(/-/g, '_')] : '';
      let fieldElement;
      switch (field.type) {
        case ('uncertain-radio'):
          fieldElement = (
            <div id={field.id} className="row">
              <div className="col-xs-4 col-sm-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name={field.id}
                  value={0}
                  checked={fieldVal !== null && fieldVal !== undefined ? Number(fieldVal) === 0 : true}
                  onChange={this.changeHandler}
                  required={required}
                  disabled={field.disabled}
                />
                &nbsp;Undecided
              </div>
              <div className="col-xs-4 col-sm-3 col-md-2">
                <input
                  type="radio"
                  className="form-check-input"
                  name={field.id}
                  value={1}
                  checked={Number(fieldVal) === 1}
                  onChange={this.changeHandler}
                  required={required}
                  disabled={field.disabled}
                />
                &nbsp;Yes
              </div>
              <div className="col-xs-4 col-sm-3 col-md-2">
                <input
                  type="radio"
                  className="form-check-input"
                  name={field.id}
                  value={-1}
                  checked={Number(fieldVal) === -1}
                  onChange={this.changeHandler}
                  required={required}
                  disabled={field.disabled}
                />
                &nbsp;No
              </div>
            </div>
          );
          break;
        case ('certain-radio'):
          fieldElement = (
            <div id={field.id} className="row">
              <div className="col-xs-4 col-sm-3 col-md-2">
                <input
                  type="radio"
                  className="form-check-input"
                  name={field.id}
                  value={1}
                  checked={Number(fieldVal) === 1}
                  onChange={this.changeHandler}
                  required={required}
                  disabled={field.disabled}
                />
                &nbsp;Yes
              </div>
              <div className="col-xs-4 col-sm-3 col-md-2">
                <input
                  type="radio"
                  className="form-check-input"
                  name={field.id}
                  value={0}
                  checked={fieldVal !== null && fieldVal !== undefined ? Number(fieldVal) === 0 : true}
                  onChange={this.changeHandler}
                  required={required}
                  disabled={field.disabled}
                />
                &nbsp;No
              </div>
            </div>
          );
          break;
        case ('textarea'):
          fieldElement = (
            <textarea
              className="form-control"
              id={field.id}
              name={field.id}
              onChange={this.changeHandler}
              required={required}
              value={fieldVal}
              placeholder={field.placeholder || null}
              disabled={field.disabled}
            />
          );
          break;
        case ('number'):
          fieldElement = (
            <input
              className="form-control"
              type={field.type}
              id={field.id}
              name={field.id}
              value={fieldVal}
              onChange={this.changeHandler}
              required={required}
              min={field.min || 0}
              placeholder={field.placeholder || null}
              disabled={field.disabled}
            />
          );
          break;
        case ('checkbox'):
          fieldElement = (
            <input
              className="form-check-input"
              style={{ marginLeft: '1em' }}
              type={field.type}
              id={field.id}
              name={field.id}
              checked={fieldVal}
              onChange={this.changeHandler}
              required={required}
              min={field.min || 0}
              disabled={field.disabled}
            />
          );
          break;
        case ('dropdown'):
          fieldElement = (
            <Select
              id={field.id}
              options={field.options}
              error={field.error}
              loading={field.loading}
              emptyValue={field.name}
              value={Boolean(fieldVal) ? fieldVal : field.name}
              onChange={this.changeHandler}
              required={required}
              disabled={disabled}
              valueProperty={field.valueProperty}
              displayProperty={field.displayProperty}
            />
          );
          break;
        default:
          fieldElement = (
            <input
              className="form-control"
              type={field.type}
              id={field.id}
              name={field.id}
              value={fieldVal}
              onChange={this.changeHandler}
              required={required}
              placeholder={field.placeholder || null}
              data-confirms={field.confirms || null}
              disabled={field.disabled}
            />
          );
          break;
      }
      return (
        <div
          className={`form-group${field.hidden ? ' hidden' : ''}`}
          key={i}
          style={{ clear: 'both' }}
        >
          <label htmlFor={field.id} style={{ color: '#848484' }}>{field.name}</label>
          {fieldElement}
        </div>
      );
    });
  }

  convertToDataType(data, toType) {
    switch (toType) {
      case ('number'): return Number(data);
      case ('boolean'): return Boolean(data);
      case ('binary'): return Boolean(data) === true ? 1 : 0;
      case ('object'): return typeof data === 'object' ? data : JSON.parse(data);
      default: return typeof data === 'object' ? JSON.stringify(data) : `${data}`;
    }
  }

  clickHandler(e) {
    e.preventDefault();
    const submitData = this.state.data;
    for (let i = 0; i < this.props.fields.length; i++) {
      if (this.props.fields[i].id.indexOf('ignore-') >= 0) {
        delete submitData[this.props.fields[i].id.replace(/-/g, '_')];
      }
    }
    const requiredErrs = this.props.fields.filter(field => {
      return field.required && !submitData[field.id.replace(/-/g, '_')];
    }).map(reqfield => {
      return reqfield.name;
    });
    const confirmErrs = this.props.fields.filter(field => {
      const confirms = field.confirms !== null && field.confirms !== undefined && field.confirms !== '';
      let matchesCounterpart = true;
      if (confirms) {
        matchesCounterpart = submitData[field.confirms.replace(/-/g, '_')] === submitData[field.id.replace(/-/g, '_')];
      }
      return confirms && !matchesCounterpart;
    }).map(reqfield => {
      const shouldMatch = this.props.fields.find(field => {
        return field.id === reqfield.confirms;
      });
      return `'${reqfield.name}' & '${shouldMatch.name}' do not match.`;
    });
    for (const dp in submitData) {
      if (Object.prototype.hasOwnProperty.call(submitData, dp)) {
        const dataType = this.props.fields.filter(field => {
          return field.id === dp.replace(/_/g, '-');
        });
        if (dataType[0] !== undefined && dataType[0] !== null) {
          submitData[dp] = submitData[dp] === null || submitData[dp] === undefined || submitData[dp] === '' ? null : this.convertToDataType(submitData[dp], dataType[0].validate ? dataType[0].validate : '');
        }
      }
    }
    this.props.clickHandler(submitData, requiredErrs, confirmErrs);
  }

  changeHandler(e) {
    const formData = this.state.data;
    let value = e.currentTarget.type !== 'checkbox' ? e.currentTarget.value : e.currentTarget.checked;
    const fieldId = Boolean(e.currentTarget.id) ? e.currentTarget.id.replace(/-/g, '_') : e.currentTarget.name.replace(/-/g, '_');
    const fieldDetails = this.props.fields.filter(field => {
      return field.id === fieldId.replace(/_/g, '-');
    });
    const isString = fieldDetails[0].validate === 'string' && typeof value === 'string';
    const isNum = fieldDetails[0].validate === 'number' && !isNaN(value);
    const isBool = (fieldDetails[0].validate === 'boolean' || fieldDetails[0].validate === 'binary') && (value === true || value === false || value === 'true' || value === 'false' || value === 0 || value === 1);
    if (isString || isNum || isBool) {
      formData[fieldId] = value;
      this.setState({ data: formData });
    }
  }

  render() {
    //  A field object in the fields prop takes 6 properties (*required):
    //  *id, name, *type, required, validate
    //  Otherwise you can place children to fill the form; or both!
    const fields = this.props.fields ? this.loadForm() : '';
    return (
      <form role="form" id={this.props.id} noValidate>
        <div className="box-body">
          {!this.props.loading ? (
            <div>
              {fields}
              {this.props.children}
              <div className="text-right">
                {this.props.moreButtons}
                {this.props.hideMainButton ? '' : (
                  <button
                    id="btn-modder"
                    className={`btn ${this.props.submitTheme || 'btn-success'}`}
                    onClick={this.clickHandler}
                    style={{ margin: '0 0 0 1em' }}
                  >
                    {this.props.submitIcon ? (
                      <i className={`fa ${this.props.submitIcon}`} />
                    ) : ''}
                    {(this.props.submitIcon && this.props.submitHeader) ? (
                      <span>&nbsp;</span>
                    ) : ''}
                    {this.props.submitHeader || 'Submit'}
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="text-center">
              <LoadStatus size="3em" color="#848484" spins />
            </div>
          )}
        </div>
      </form>
    );
  }
}

Form.propTypes = {
  loading: PropTypes.bool,
  id: PropTypes.string,
  fields: PropTypes.array,
  data: PropTypes.object,
  clickHandler: PropTypes.func,
  submitIcon: PropTypes.string,
  submitHeader: PropTypes.string,
  submitTheme: PropTypes.string,
  hideMainButton: PropTypes.bool,
  moreButtons: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ])
};
Form.defaultProps = {
  hideMainButton: false
};

export default Form;
